// extracted by mini-css-extract-plugin
export var phone = "_19-0";